
















import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { getCollegeWorkList, getMajorList } from '../api/index';
import SyVoteItem from '../components/SyVoteItem.vue';
import PickerInput from '@/components/PickerInput.vue';
Vue.use(List);
@Component({
  components: {
    SyVoteItem,
    PickerInput,
  },
})
export default class SyVoteList extends Vue {
  @Prop() voteName!: string;
  @Prop({ default: 'vote-list-rand' }) sortBy!: string;
  @Prop() college!: string;
  @Prop() major!: string;
  @Prop() search!: string;
  loading = false;
  finished = false;
  page: number = 1;
  voteList: any[] = [];

  async created() {
    this.onGetVoteList();
  }

  async onGetVoteList() {
    this.loading = true;
    try {
      const res = await getCollegeWorkList({
        sort: this.sortBy,
        major: this.major,
        college: this.college,
        voteName: this.voteName,
        search: this.search,
        page: this.page,
      });
      if (!res.data.length) {
        this.finished = true;
        return;
      }
      this.voteList = [...this.voteList, ...res.data];
    } catch (e) {
      console.log('请求出错', e);
      // this.finished = true;
    }
    this.loading = false;
    if (this.loading || this.finished) {
      console.log('列表全部加载完成或加载中');
      return;
    }
    this.page++;
    if (this.sortBy === 'vote-list-rand') {
      this.finished = true;
    }
  }
  // reset status
  resetStatus() {
    this.page = 1;
    this.voteList = [];
    this.finished = false;
  }
  navTo(index: number) {
    this.$router.push({
      path: 'WorkDetail',
      query: {
        id: this.voteList[index].id as string,
      },
    });
    return this.voteList[index];
  }

  @Watch('sortBy')
  onSortByChange() {
    this.resetStatus();
    this.onGetVoteList();
  }
  @Watch('major')
  onMajorChange() {
    console.log('change major, reload...');
    this.resetStatus();
    this.onGetVoteList();
  }
  @Watch('college')
  onCollegeChange() {
    this.resetStatus();
    this.onGetVoteList();
  }
  @Watch('search')
  onSearchChange() {
    this.resetStatus();
    this.onGetVoteList();
  }
}
